export default __webpack_public_path__ + "static/media/dots.1add36c0.png";